<template>
  <drag-dialog
    :visible.sync="visible"
    title="重置密码"
    width="600px"
    height="400px"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm')"
  >
    <el-form :model="editForm" ref="editForm" :rules="rules" label-width="100px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="24">
          <el-form-item label="用户名称" prop="name">
            <el-input v-model.trim="editForm.name" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="登录账号" prop="loginName">
            <el-input v-model.trim="editForm.loginName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="重置密码" prop="password">
            <el-input type="password" v-model="editForm.password" show-password></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="确认密码" prop="checkPassword">
            <el-input type="password" v-model="editForm.checkPassword" show-password></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button type="primary" @click="handleSubmit">确 认</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import { changePassword } from '@api/user';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    var validatePwd1 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入重置密码'));
      } else {
        callback();
      }
    };
    var validatePwd2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请确认重置密码'));
      } else {
        if (value !== this.editForm.password) {
          callback(new Error('两次输入的密码不一致'));
        } else {
          callback();
        }
      }
    };
    return {
      editForm: {},
      rules: {
        name: [{ required: true, message: '请输入用户名称', trigger: 'blur' }],
        loginName: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
        password: [{ required: true, validator: validatePwd1, trigger: 'blur' }],
        checkPassword: [{ required: true, validator: validatePwd2, trigger: 'blur' }]
      },
      submitLoading: false
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val && this.user.id) {
        this.editForm.name = this.user.name;
        this.editForm.loginName = this.user.login_name;
      }
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm(`您确认要重置该用户密码吗？`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(async () => {
              this.submitLoading = true;

              try {
                await changePassword(this.editForm);
                this.$message.success('密码修改成功！');
                this.$emit('update:visible', false);
              } finally {
                this.submitLoading = false;
              }
            })
            .catch(() => {});
        }
      });
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped></style>
